import { useState } from "react";
import { useExtracted } from "next-intl";

const WARNING_DAYS = 7;

export function ExpiryBanner({
  expiresAt,
  tier,
}: {
  expiresAt: string | null;
  tier: string | null;
}) {
  const te = useExtracted();
  const MEMBERSHIP_EXPIRES_TOMORROW = te("Membership expires tomorrow");
  const TRIAL_ENDS_TOMORROW = te("Trial ends tomorrow");
  const ADD_TIME = te("Add Time");
  const [now] = useState(() => Date.now());

  if (!expiresAt) return null; // admin-granted permanent access

  const days = Math.max(
    0,
    Math.ceil((new Date(expiresAt).getTime() - now) / 86400000),
  );
  if (days > WARNING_DAYS) return null;

  const isStandardTrial = tier === "standard";

  return (
    <div className="flex items-center justify-center gap-2 border-b border-yellow-500/20 bg-yellow-500/10 px-3 py-1.5 text-base text-yellow-400">
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-yellow-500" />
      <span>
        {isStandardTrial
          ? days === 1
            ? TRIAL_ENDS_TOMORROW
            : te("Trial ends in {days} days", { days: String(days) })
          : days === 1
            ? MEMBERSHIP_EXPIRES_TOMORROW
            : te("Membership expires in {days} days", {
                days: String(days),
              })}
      </span>
      <a
        className="ml-2 underline underline-offset-2 transition-colors hover:text-yellow-300"
        href="/purchase"
      >
        {ADD_TIME}
      </a>
    </div>
  );
}
